import { render } from "./FailureTwo.vue?vue&type=template&id=7ef8ad6a&scoped=true"
import script from "./FailureTwo.vue?vue&type=script&lang=js"
export * from "./FailureTwo.vue?vue&type=script&lang=js"

import "./FailureTwo.vue?vue&type=style&index=0&id=7ef8ad6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef8ad6a"]])

export default __exports__